import { useQuery } from '@tanstack/react-query';

import { useAuth0 } from '@auth0/auth0-react';

import UserService from '../services/UserService';

export default function useUserData() {
  const { isAuthenticated } = useAuth0();

  const {
    data: me,
    isFetching,
    isFetched,
  } = useQuery({
    queryKey: ['me'],
    queryFn: UserService.getMe,
    enabled: isAuthenticated,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
  });

  return { user: me, isFetching, isFetched };
}
